module.exports = __webpack_public_path__ + "static/media/RicHickeyinside.fc87ef54.webp";